import { render, staticRenderFns } from "./ProvinceSelection.vue?vue&type=template&id=5e46ed73&"
import script from "./ProvinceSelection.vue?vue&type=script&lang=js&"
export * from "./ProvinceSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports